import React from 'react';
import { Tag } from 'lucide-react';

interface TagBadgeProps {
  label: string;
}

export default function TagBadge({ label }: TagBadgeProps) {
  return (
    <span className="flex items-center gap-1 text-[0.65rem] font-bold uppercase tracking-wider bg-teal-pale text-teal px-2 py-0.5 rounded-full">
      <Tag size={9} />
      {label}
    </span>
  );
}
